// extracted by mini-css-extract-plugin
module.exports = {"InputNumberWrapper":"SpecificRange_InputNumberWrapper__1EjKJ","InputNumber":"SpecificRange_InputNumber__2gj1Z"};